export default __webpack_public_path__ + "static/media/lose@2x.579b1c23.png";